import { format, getUnixTime, parseISO } from 'date-fns';

export const formatDateTime = (dateString: string): string => {
  return format(parseISO(dateString), 'yyyy/MM/dd HH:mm');
};

export const toUnixTimestamp = (dateString: string): number => {
  return getUnixTime(parseISO(dateString));
};
